<template>
  <v-form @submit.prevent class="enterform">
    <BetTypeEntry :bettype="localDatalist.checkin.bettype" @bettypeclick="betTypeReturned" />

    <v-row>
      <DateEntry :passeddate="sessiondate" @dateentered="dateEntered"/>
      <TimeEntry :passedtime="sessionStartTime" @timeentered="startTimeEntered"/>

      <v-col cols="12">
         <v-combobox
          v-model="place"
          label="Where did you play?"
          :items="allplace"
        ></v-combobox>
      </v-col>

      <v-col cols="12">
         <v-combobox
          v-model="game"
          label="What game did you play?"
          :items="gameslist"
        ></v-combobox>
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="localDatalist.checkin.buyin"
          label="What was the total entry fee?"
          type="number"
          step=".01"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="localDatalist.checkin.players"
          label="How many players entered the tournament?"
          type="number"
          step="1"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="localDatalist.checkin.notes"
          label="Any notes you want to save?"
        ></v-text-field>
      </v-col>

      <v-col cols="12" class="text-center">
        <v-btn @click="enterSession">Enter</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue';
import { useUserStore } from '@/stores/users';
import { usePlaceStore } from '@/stores/places';
import { useGameStore } from '@/stores/games';
import BetTypeEntry from '@/components/custom/BetTypeEntry.vue';
import DateEntry from '@/components/custom/DateEntry.vue';
import TimeEntry from '@/components/custom/TimeEntry.vue';
import { useConvertTime } from '@/compostables/useTimeConversion.js';
import  {updateDropDown}  from '@/api/lists.js';
import { GAMES_DB, PLACES_DB, TOURNAMENT } from '@/constants/constants';

const { timeToText } = useConvertTime();

const props = defineProps(['datalist']);
const localDatalist = ref(JSON.parse(JSON.stringify(props.datalist)));

const emit = defineEmits(['update:datalist', 'entered']);

const feedback = ref('');
const place = ref(null);
const game = ref(null);
const sessiondate = reactive({
  enteredDate: new Date(),
  label: 'Session Start Date'
});
const sessionStartTime = reactive ({
  endteredTime: ref(new Date(),'fullTime24h'),
  label: 'What time did you start?'
})

const userStore = useUserStore();
const placeStore = usePlaceStore();
const gameStore = useGameStore();


const gameslist = computed(() => gameStore.gameslist);

const allplace = computed(() => {
  if (userStore.favoriteplaces) {
    return userStore.favoriteplaces.concat(
      placeStore.placelist.filter(place => !userStore.favoriteplaces.includes(place))
    );
  } else {
    return placeStore.placelist;
  }
});

onMounted(() => {
  localDatalist.value.checkin.sessionstartdate =
    localDatalist.value.checkin.sessionstartdate instanceof Date
      ? localDatalist.value.checkin.sessionstartdate
      : new Date();
  localDatalist.value.checkin.starttime = timeToText(new Date());
  place.value = localDatalist.value.checkin.place;
  game.value = localDatalist.value.checkin.game;
  sessiondate.value = localDatalist.value.checkin.sessionstartdate;
});

const betTypeReturned = payload => {
  localDatalist.value.checkin.bettype = payload.localvar;
  emit('update:datalist', localDatalist);
};

const enterSession = () => {
  feedback.value = null;
  localDatalist.value.checkin.sessionstartdate = sessiondate.value;

  Promise.all([
    updateDropDown(game.value, GAMES_DB, localDatalist.value.user.user_id),
    updateDropDown(place.value, PLACES_DB, localDatalist.value.user.user_id)
  ])
    .then(([gamechoice, placechoice]) => {
      if (sessiondate.value && gamechoice && placechoice) {
        const newrecord = {
          from: localDatalist.value.user.alias,
          user_id: localDatalist.value.user.user_id,
          sessiondate: new Date(localDatalist.value.checkin.sessionstartdate),
          place: placechoice,
          type: TOURNAMENT,
          game: gamechoice,
          notes: localDatalist.value.checkin.notes,
          bettype: localDatalist.value.checkin.bettype,
          buyin: Number(localDatalist.value.checkin.buyin),
          players: Number(localDatalist.value.checkin.players),
          starttime: localDatalist.value.checkin.starttime
        };
        feedback.value = 'Checked in!';
        emit('entered', { newrecord });
      } else {
        feedback.value = 'Enter all required information';
      }
    })
    .catch(err => {
      console.error('Error entering session:', err);
    });
};
function dateEntered(payload) {
  localDatalist.value.checkin.sessionstartdate = payload;
  
}
function startTimeEntered(payload) {
  localDatalist.value.checkin.sessionstarttime = payload;
  
}

</script>

<style>
.enterform {
  max-width: 500px;
  width: 80%;
  margin: 0 auto;
  position: relative;
}
.input {
  border: medium none !important;
  margin: 0 0 10px;
  padding-left: 6px;
  min-width: 100%;
  padding: 0;
  width: 100%;
}
.checkbox {
  padding-top: 60px
}
.label {
  text-align: left;
  padding-left: 0px;
  color: black;
}
.center {
  text-align: center;
}
</style>

